import { CONFIG } from './constants';

const GOOGLE_AD_URL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

const configureAdsByGoogle = () => {
  // @ts-ignore
  if (!window.adsbygoogle || !window.adsbygoogle.loaded) {
    window.adsbygoogle = window.adsbygoogle || [];
  }
};

const configureBreaks = () => {
  // @ts-ignore
  window.adBreak = window.adConfig = function (o) {
    window.adsbygoogle.push(o);
  };
  window.adConfig({ preloadAdBreaks: 'on' });
};

const downloadAdsForBanners = () =>
  new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = GOOGLE_AD_URL;
    script.defer = true;
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject(new Error('ads for banner failed to load'));
    };

    if (process.env.NEXT_RUNTIME !== 'production') {
      script.setAttribute('data-adtest', 'on');
    }

    document.body.appendChild(script);
  });

const downloadAdsForBreaks = () =>
  new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${GOOGLE_AD_URL}?client=${CONFIG.publisherId}`;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject(new Error('ads for breaks failed to load'));
    };

    if (process.env.NEXT_RUNTIME !== 'production') {
      script.setAttribute('data-adbreak-test', 'on');
    }
    script.setAttribute('data-ad-frequency-hint', '30s');

    document.head.appendChild(script);
  });

export const downloadAds = () =>
  Promise.allSettled([downloadAdsForBreaks(), downloadAdsForBanners()]).then(([breaks, banners]) => {
    if (breaks.status === 'fulfilled') {
      configureAdsByGoogle();
      configureBreaks();
      return;
    }

    if (banners.status === 'fulfilled') {
      return configureAdsByGoogle();
    }

    throw new Error([breaks.reason, banners.reason].join('\n'));
  });
